import { createRefPath } from "../../appData/appRefPaths";

export const fsUpdate_addListDoc = (props) => {
  const { database_fns, baseRef, ufProps, dispatch } = props
  const { refPath } = baseRef
  const { createListProps } = ufProps ?? {}

  const { createListAs, createListData } = createListProps ? createListProps : {}
  const _addRef = createRefPath([createListAs], refPath)

  database_fns.add_doc(_addRef, createListData, dispatch)
}